import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation RemovePages(
    $removePageIds: [ID!]!
    $zoneId: ID!
    $tenantId: ID!
    $appId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          removePages(ids: $removePageIds)
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.always(undefined)

export const executor = graphql.createExecutor<
  graphql.schema.RemovePagesMutation,
  void,
  graphql.schema.RemovePagesMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
